module.exports = __webpack_public_path__ + "img/coastal-alabama-logo.92a5e2e2.jpg";